import { useAuth } from '@clerk/nextjs';
import {
  fetchStressLevels as fetchStressLevelsService,
  submitTestResult as submitTestResultService,
} from '@/services/stressTestService';

interface TestResultType {
  score: number;
}

interface StressLevelResponse {
  labels: string[];
  data: number[];
}

export const useStressTestService = () => {
  const { getToken } = useAuth();

  const submitTestResult = async (testResult: TestResultType): Promise<void> => {
    const token = await getToken();
    if (!token) throw new Error('No auth token available');
    await submitTestResultService(testResult, token);
  };

  const fetchStressLevels = async (auth_user_id: string): Promise<StressLevelResponse> => {
    const token = await getToken();
    if (!token) throw new Error('No auth token available');
    return fetchStressLevelsService(auth_user_id, token);
  };

  return {
    submitTestResult,
    fetchStressLevels,
  };
};
